import { TreeItem, TreeView } from '@material-ui/lab'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clubLoader, getClubList, selectClubList } from './state/clubSlice'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { Box, Button, Grid, makeStyles } from '@material-ui/core'
import { useHistory } from 'react-router'
import { getRoleEnum, roleLabel } from '@types'
import Loader from '@views/shared/Loader'

interface GeneratorProps {
  node: any
  index?: string
}

const useStyles = makeStyles({
  root: {
    '&.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label': {
      backgroundColor: '#fff !important'
    }
  }
})

const getRoleColor = (role: string) => {
  switch (role) {
    case 'admin':
      return '#ff6905'
    case 'agente':
      return '#ffc06e'
    case 'ejecutivo':
      return '#fc6404'
    default:
      return '#ffe2c4'
  }
}

const TreeItemGenerator: React.FC<GeneratorProps> = ({ node, index }) => {
  const classes = useStyles()
  return (
    <>
      <TreeItem
        nodeId={node._id}
        classes={{
          root: classes.root
        }}
        label={
          <div
            className="clubList-item"
            style={{
              backgroundColor: getRoleColor(node.role)
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} lg={4}>
                {index && index?.length > 0 ? <span>{index}. </span> : <></>}
                {node.name?.toUpperCase()}
              </Grid>
              <Grid item xs={4} sm={2} md={2} lg={2}>
                {roleLabel[getRoleEnum(node.role)]}
              </Grid>
              <Grid item xs={4} sm={2} md={2} lg={2}>
                {node.phone}
              </Grid>
              <Grid item xs={4} sm={2} md={2} lg={2}>
                {node.city}
              </Grid>
            </Grid>
          </div>
        }
        key={node._id}
      >
        {node.children &&
          node.children.map(
            (child: any, index: number) =>
              child.children && <TreeItemGenerator node={child} key={child._id} index={`${index + 1}`} />
          )}
      </TreeItem>
    </>
  )
}

const TeamList: React.FC = () => {
  const dispatch = useDispatch()
  const { isLoading } = useSelector(clubLoader)
  const clubList = useSelector(selectClubList)
  const history = useHistory()
  const handleClick = () => {
    history.push('signup/miembro')
  }
  useEffect(() => {
    dispatch(getClubList())
  }, [])
  if (isLoading) {
    return (
      <Box padding="1.5em">
        <Box
          position="absolute"
          style={{ top: '50%', left: '50%' }}
          width="0px"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          overflow="visible"
          flexWrap="nowrap"
          whiteSpace="nowrap"
        >
          <Loader isLoading={true} />
          <Box marginTop="0.5rem">Obteniendo datos del club...</Box>
        </Box>
      </Box>
    )
  }
  return (
    <Box padding="1.5em">
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
        defaultExpanded={[clubList?._id || '']}
      >
        {clubList ? <TreeItemGenerator node={clubList} /> : null}
      </TreeView>
      <Box height="50px" />
      <Button variant="contained" color="primary" onClick={() => handleClick()}>
        Agregar referenciador
      </Button>
    </Box>
  )
}

export default TeamList
